import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { GroupQuestionCreateComponent } from './group-questions/group-question-create/group-question-create.component';
import { GroupQuestionDetailComponent } from './group-questions/group-question-detail/group-question-detail.component';
import { DebateDetailComponent } from './debates/debate-detail/debate-detail.component';

const tutorizationRoutes: Routes = [
  {
    path: 'tutorization',
    title: 'parentTutorization',
    children: [
      {
        path: 'group-questions/new',
        title: 'newTutorizationGroupQuestion',
        component: GroupQuestionCreateComponent,
        canActivate: [ProfileGuard],
        data: { action: 'questions.create' }
      },
      {
        path: 'group-questions/:id',
        title: 'tutorizationGroupQuestionId',
        component: GroupQuestionDetailComponent,
        canActivate: [ProfileGuard],
        data: { action: 'questions.detail' }
      },
      {
        path: 'debates',
        title: 'tutorizationDebates',
        resolve: {},
        children: [
          {
            path: ':debateId',
            title: 'tutorizationDebateIdDetail',
            resolve: {},
            children: [
              {
                path: '',
                component: DebateDetailComponent,
                resolve: {}
              }
            ],
            canActivate: [ProfileGuard]
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(tutorizationRoutes)],
  exports: [RouterModule]
})
export class TutorizationRoutingModule {}
